import { memo } from 'react';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { Collapse, Panel } from '@geneui/components';
// Import Components
import KeyValueItems from 'components/common/KeyValueItems';
// Import Constants
import { l } from 'constants/common';

interface Props {
    data: {
        name: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        items: any[];
        isTranslated?: boolean;
    }[];
    isAllActive?: boolean;
    withPanel?: boolean;
}

const CollapseItemsGroup = ({ data, isAllActive = false, withPanel = true }: Props) => {
    const { t } = useTranslation();

    return (
        <div className="collapse-items-group">
            <Collapse allActive={isAllActive}>
                {data.map(({ name, items, isTranslated }, index) =>
                    withPanel ? (
                        <Panel key={index} title={isTranslated ? name : t(l[name])}>
                            <KeyValueItems items={items} vertical />
                        </Panel>
                    ) : (
                        <KeyValueItems key={index} items={items} vertical />
                    ),
                )}
            </Collapse>
        </div>
    );
};

export default memo(CollapseItemsGroup);
